import { render, staticRenderFns } from "./ManageMemberPhonenumbers.vue?vue&type=template&id=45544f67&"
import script from "./ManageMemberPhonenumbers.vue?vue&type=script&lang=js&"
export * from "./ManageMemberPhonenumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports